import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { useEffect } from "react";

const DialogLayout = ({ show, children, inline = false, onClose = () => {} }: any) => {
  useEffect(() => {
    if (inline) return;
    let scrollY = 0;
    if (show) {
      scrollY = window.scrollY;
      document.body.style.top = `-${scrollY}px`;
      document.documentElement.classList.add("overflow-hidden");
      document.body.classList.add("overflow-hidden");
    }
    return () => {
      document.documentElement.classList.remove("overflow-hidden");
      document.body.classList.remove("overflow-hidden");
      document.body.style.top = "";
      window.scrollTo(0, scrollY);
    };
  }, [show, inline]);

  if (inline) {
    if (!show) return null;
    return (
      <div
        className="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-500/75 w-full h-full"
        onClick={onClose}
      >
        <div
          className="relative z-[10000] transform overflow-hidden rounded-lg bg-white text-left shadow-xl w-full max-w-sm max-h-[90vh] overflow-y-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="w-full h-full">{children}</div>
        </div>
      </div>
    );
  }

  return (
    <Dialog static={false} open={show} onClose={onClose} className="relative z-20">
      <DialogBackdrop className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in" />

      <div className="fixed inset-0 z-50 w-screen flex items-center justify-center">
        <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0 z-50">
          <DialogPanel className="relative z-50 transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in data-closed:sm:translate-y-0 data-closed:sm:scale-95">
            <div className={"w-full h-full z-50"}>{children}</div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default DialogLayout;
